function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1972(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27,
    height: 13.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9457142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 6.81
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.62,
    width: 27,
    height: 18.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 22.64
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.66,
    width: 27,
    height: 19.18,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 41.25
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50.84,
    width: 27,
    height: 24.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.481
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 63.245000000000005
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 75.65,
    width: 27,
    height: 28.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 89.79
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.93,
    width: 27,
    height: 28.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 118.09
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 132.25,
    width: 27,
    height: 29.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 147.055
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 161.86,
    width: 27,
    height: 31.56,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 177.64000000000001
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.42,
    width: 27,
    height: 33.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 210.045
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 226.67,
    width: 27,
    height: 33.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.857142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 243.36499999999998
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 260.05,
    width: 27,
    height: 33.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 276.78000000000003
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 293.51,
    width: 27,
    height: 34.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 310.66499999999996
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 327.82,
    width: 27,
    height: 38.05,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 346.84499999999997
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 365.86,
    width: 27,
    height: 40.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 386.33000000000004
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 406.8,
    width: 27,
    height: 42.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 427.83500000000004
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 448.87,
    width: 27,
    height: 44.02,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 470.88
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 492.89,
    width: 27,
    height: 49.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 517.6899999999999
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 542.49,
    width: 27,
    height: 49.93,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 567.455
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.42,
    width: 27,
    height: 52.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 618.505
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 644.59,
    width: 27,
    height: 55.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.5,
    y: 672.2950000000001
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 0,
    width: 35.14,
    height: 43.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.57,
    y: 21.79
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.14,
    y: 0,
    width: 35.45,
    height: 43.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.43125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.86500000000001,
    y: 21.79
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.6,
    y: 0,
    width: 35.75,
    height: 43.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.958333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.475,
    y: 21.79
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.35,
    y: 0,
    width: 37.02,
    height: 43.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.288571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.85999999999999,
    y: 21.79
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 0,
    width: 37.61,
    height: 43.58,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.70125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.175,
    y: 21.79
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.98,
    y: 0,
    width: 39.61,
    height: 43.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.658571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.785,
    y: 21.79
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.59,
    y: 0,
    width: 40.27,
    height: 43.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.711666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.725,
    y: 21.79
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.86,
    y: 0,
    width: 40.51,
    height: 43.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.06375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.115,
    y: 21.79
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.37,
    y: 0,
    width: 43.18,
    height: 43.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.96,
    y: 21.79
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.55,
    y: 0,
    width: 44.23,
    height: 43.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.665,
    y: 21.79
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.78,
    y: 0,
    width: 45.09,
    height: 43.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.263333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 438.325,
    y: 21.79
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.87,
    y: 0,
    width: 45.85,
    height: 43.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.358
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.795,
    y: 21.79
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.72,
    y: 0,
    width: 46.51,
    height: 43.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9618181818181815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.975,
    y: 21.79
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.22,
    y: 0,
    width: 48.1,
    height: 43.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.263333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.27,
    y: 21.79
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.32,
    y: 0,
    width: 48.89,
    height: 43.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.7650000000001,
    y: 21.79
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.21,
    y: 0,
    width: 49.79,
    height: 43.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.358
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.105,
    y: 21.79
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 43.58,
    width: 49.84,
    height: 48.01,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.602
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 67.585
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 91.59,
    width: 49.84,
    height: 51.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 117.305
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 143.02,
    width: 49.84,
    height: 51.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 168.81
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 194.6,
    width: 49.84,
    height: 51.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 220.57999999999998
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 246.56,
    width: 49.84,
    height: 53.5,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 273.31
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 300.06,
    width: 49.84,
    height: 54.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.153333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 327.265
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 354.47,
    width: 49.84,
    height: 55.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.537777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 382.00500000000005
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 409.53,
    width: 49.84,
    height: 55.81,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 437.43499999999995
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 465.35,
    width: 49.84,
    height: 57.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.537777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 494.19
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 523.02,
    width: 49.84,
    height: 58.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.537777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 552.265
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 581.51,
    width: 49.84,
    height: 59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 611.01
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 640.52,
    width: 49.84,
    height: 59.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.92,
    y: 670.26
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 43.58,
    width: 49.62,
    height: 60.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.65,
    y: 74
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.46,
    y: 43.58,
    width: 50.77,
    height: 60.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.252857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.845,
    y: 74
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.22,
    y: 43.58,
    width: 51.49,
    height: 60.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.298
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.965,
    y: 74
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.71,
    y: 43.58,
    width: 52.65,
    height: 60.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.035,
    y: 74
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.36,
    y: 43.58,
    width: 52.72,
    height: 60.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.531428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.72,
    y: 74
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.08,
    y: 43.58,
    width: 53.72,
    height: 60.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.94,
    y: 74
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.8,
    y: 43.58,
    width: 56.46,
    height: 60.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.03000000000003,
    y: 74
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444.26,
    y: 43.58,
    width: 60.53,
    height: 60.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.56625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 474.525,
    y: 74
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.79,
    y: 43.58,
    width: 63.12,
    height: 60.84,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.35,
    y: 74
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.91,
    y: 43.58,
    width: 63.57,
    height: 60.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.6949999999999,
    y: 74
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.48,
    y: 43.58,
    width: 68.52,
    height: 60.84,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.74,
    y: 74
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 104.43,
    width: 67.24,
    height: 63.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 136.065
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 167.69,
    width: 67.24,
    height: 63.86,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.772
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 199.62
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 231.55,
    width: 67.24,
    height: 64.18,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.168571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 263.64
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 295.74,
    width: 67.24,
    height: 65.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.412857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 328.685
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 361.63,
    width: 67.24,
    height: 65.95,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.421428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 394.605
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 427.58,
    width: 67.24,
    height: 66.3,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 460.72999999999996
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 493.88,
    width: 67.24,
    height: 66.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.522857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 527.21
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 560.54,
    width: 67.24,
    height: 68.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.447999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 594.935
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.84,
    y: 629.33,
    width: 67.24,
    height: 70.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.605714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.46000000000001,
    y: 664.6650000000001
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.08,
    y: 104.43,
    width: 62.2,
    height: 77.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.18,
    y: 143.27
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.28,
    y: 104.43,
    width: 62.86,
    height: 77.68,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.984444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.71,
    y: 143.27
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.14,
    y: 104.43,
    width: 64.32,
    height: 77.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.863999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.29999999999995,
    y: 143.27
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.46,
    y: 104.43,
    width: 68.58,
    height: 77.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.75,
    y: 143.27
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.04,
    y: 104.43,
    width: 73.77,
    height: 77.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.4425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 438.925,
    y: 143.27
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.81,
    y: 104.43,
    width: 74.65,
    height: 77.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.441666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.135,
    y: 143.27
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.46,
    y: 104.43,
    width: 74.74,
    height: 77.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.456666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.83,
    y: 143.27
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.19,
    y: 104.43,
    width: 74.81,
    height: 77.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.35125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.595,
    y: 143.27
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.08,
    y: 182.11,
    width: 72.81,
    height: 80.52,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.10125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.485,
    y: 222.37
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.08,
    y: 262.63,
    width: 72.81,
    height: 83.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.401428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.485,
    y: 304.6
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.08,
    y: 346.57,
    width: 72.81,
    height: 84.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.485,
    y: 388.775
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.08,
    y: 430.98,
    width: 72.81,
    height: 87.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.562000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.485,
    y: 474.94500000000005
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.08,
    y: 518.91,
    width: 72.81,
    height: 90.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.281000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.485,
    y: 564.125
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.08,
    y: 609.34,
    width: 72.81,
    height: 90.66,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.2025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 180.485,
    y: 654.6700000000001
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.89,
    y: 182.11,
    width: 86.72,
    height: 77.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.25,
    y: 221.085
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 182.11,
    width: 93.88,
    height: 77.95,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.135714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 350.54,
    y: 221.085
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.49,
    y: 182.11,
    width: 99.54,
    height: 77.95,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.74375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.26,
    y: 221.085
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.03,
    y: 182.11,
    width: 101.03,
    height: 77.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.991666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.545,
    y: 221.085
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.06,
    y: 182.11,
    width: 101.94,
    height: 77.95,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.74375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.03,
    y: 221.085
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.89,
    y: 260.06,
    width: 109.33,
    height: 75.59,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.871818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.555,
    y: 297.855
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.89,
    y: 335.65,
    width: 109.33,
    height: 83.44,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.688
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.555,
    y: 377.37
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.89,
    y: 419.09,
    width: 109.33,
    height: 87.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.555,
    y: 462.69
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.89,
    y: 506.3,
    width: 109.33,
    height: 95.54,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.64857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.555,
    y: 554.07
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.89,
    y: 601.84,
    width: 109.33,
    height: 98.16,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.555,
    y: 650.9200000000001
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.22,
    y: 260.06,
    width: 114.27,
    height: 97.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.768
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.355,
    y: 308.9
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.49,
    y: 260.06,
    width: 121.89,
    height: 97.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.435,
    y: 308.9
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.37,
    y: 260.06,
    width: 137.63,
    height: 97.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.185,
    y: 308.9
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.22,
    y: 357.74,
    width: 107.62,
    height: 136.69,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.4525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.03000000000003,
    y: 426.08500000000004
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.22,
    y: 494.43,
    width: 107.62,
    height: 205.57,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.374285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.03000000000003,
    y: 597.215
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.84,
    y: 357.74,
    width: 127.12,
    height: 205.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 497.4,
    y: 460.27
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.96,
    y: 357.74,
    width: 139.04,
    height: 205.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.48,
    y: 460.27
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.84,
    y: 562.8,
    width: 266.16,
    height: 137.2,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.47272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.92,
    y: 631.4
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1972);
export default __webpack_public_path__ + "static/media/1972.cade6f2c8298e0cf0a68a964fb08d791.svg";
export { ForwardRef as ReactComponent };